"use strict";

import {initAjaxFormMap as initAjaxFormMapGoogle} from "../libs/@elements/ajax-form-map/ajax-form-google";
import {findAll, findIn, findAllIn, on, closest, addClass, removeClass} from '../libs/@elements/dom-utils';
import {onFind} from "../libs/@elements/init-modules-in-scope";
import {getApi} from "../libs/@elements/google-map";
// import {cookieConsentCallback} from "./cookie-consent-callback";

window._config.lang = window['_config'].lang;

const isMobile = () => matchMedia('(max-width: 767px)').matches;

export function init () {
    // cookieConsentCallback('C0003', function () {
    //     console.log("init dsgvo map");
    //     initDsgvoMap();
    // });

    // function initDsgvoMap() {

        function getGooglePoiStyles(){
            return {
                bm: {
                    default: {
                        url: '/static/img/map/pois/poi-baumaschinen.svg',
                        size: new google.maps.Size(32, 42),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(12, 41)
                    },
                    active: {
                        url: '/static/img/map/pois/poi-active.svg',
                        size: new google.maps.Size(32, 42),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(12, 41)
                    }
                },
                lt: {
                    default: {
                        url: '/static/img/map/pois/poi-ladetechnik.svg',
                        size: new google.maps.Size(32, 42),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(12, 41)
                    },
                    active: {
                        url: '/static/img/map/pois/poi-active.svg',
                        size: new google.maps.Size(32, 42),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(12, 41)
                    }
                },
                gp: {
                    default: {
                        url: '/static/img/map/pois/poi-group.svg',
                        size: new google.maps.Size(32, 42),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(12, 41)
                    },
                    active: {
                        url: '/static/img/map/pois/poi-active.svg',
                        size: new google.maps.Size(32, 42),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(12, 41)
                    }
                }
            };
        }
        // bm = baumaschinen, lt = ladetechnik, gp = group

        function getGoogleInfoBoxOptions(){
            let width = isMobile() ? "300px" : "600px";
            let offsetX = isMobile() ? -150 : -158;
            let offsetY = isMobile() ? -22 : -50;

            return {
                pixelOffset: new google.maps.Size(offsetX, offsetY),
                boxStyle: {width: width, padding: "0"},
                boxClass: "info-box",
                closeBoxURL: "/static/img/close.svg"
            };
        }

        function onActivateMarker(container, marker, api) {
            if (marker.detailInfo) {
                let item = findIn(`.js-ajax-form-map-google__item[data-item-id="${marker.detailInfo}"]`, container);
                let items = findAllIn('.js-ajax-form-map-google__item', container);

                items.map(function(element) {
                    removeClass('is-active', element);
                });

                if(item) {
                    addClass('is-active', item);
                    const isMobile = () => matchMedia('(max-width: 767px)').matches;

                    let parentUl = closest('.scrolling-content', item),
                        childPos = item.offsetTop;

                    if (isMobile()) {
                        item.scrollIntoView({
                            behaviour: 'smooth',
                        });
                    }else{
                        parentUl?.scrollTo({
                            top: childPos,
                            behavior: 'smooth'
                        });
                    }
                }
            }
        }

        function onDeactivateMarker(container, marker, api) {
            if (marker.detailInfo) {
                let items = findAllIn('.js-ajax-form-map-google__item', container);
                items.map(function(element) {
                    removeClass('is-active', element);
                });
            }
        }
        onFind('.js-ajax-form-map-google', function(googleMap) {

            let mapObj = findIn('.js-ajax-form-map-google__map__canvas', googleMap);
            // let initialLat = +googleMap.getAttribute('data-google-map-initial-lat') || 47.2183939;
            // let initialLng = +googleMap.getAttribute('data-google-map-initial-lng') || 14.306775;

            onFind('.js-ajax-form-map-google__item', function (item) {
                let items = findAllIn('.js-ajax-form-map-google__item', googleMap);
                on('click', function (evt) {
                    let item = evt.currentTarget;
                    items.map(function (element) {
                        removeClass('is-active', element);
                    });
                    addClass('is-active', item);
                    let itemId = item.dataset.itemId;

                    getApi(mapObj).then(function (api) {
                        let markers = api.getMarkers();
                        markers.map(function (marker) {
                            if (marker.detailInfo === itemId) {
                                api.activateMarker(marker);
                            }
                        })
                    });
                }, item)
            })

            let selectors = {
                result: '.js-ajax-form-map-google__result',
                loading: '.js-ajax-form-map-google__loading',
                notifications: '.js-ajax-form-map-google__notifications',
                form: '.js-ajax-form-map-google__form',
                additionalForm: '.js-ajax-form-map-google__additional-form',
                errorArea: '.js-ajax-form-map-google__error-area',
                retry: '.js-ajax-form-map-google__retry',
                link: '.js-ajax-form-map-google__link',
                reset: '.js-ajax-form-map-google__reset',
            };

            let map = initAjaxFormMapGoogle(googleMap, {
                submitOnChange: true,
                element: findIn('.js-ajax-form-map-google__map__canvas', googleMap),
                poiStyles: () => getGooglePoiStyles(),
                infoBoxOptions: () => getGoogleInfoBoxOptions(),
                clustering: true,
                onActivateMarker: (marker, api) => onActivateMarker(googleMap, marker, api),
                onDeactivateMarker: (marker, api) => onDeactivateMarker(googleMap, marker, api),
                mapOptions: {
                    zoom: 10,
                    scrollwheel: true,
                    mapTypeControl: false,
                    streetViewControl: false,
                    style: [
                        {
                            "featureType": "administrative.locality",
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "visibility": "on"
                                }
                            ]
                        },
                        {
                            "featureType": "landscape.natural",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        }
                    ]
                }
            }, selectors);
        })
    // }

}